// extracted by mini-css-extract-plugin
export default {"actors-button-wrapper":"DiscountProgramActors_actors-button-wrapper__M8Kps"};